/**
 * /eric/input-requests — operator input-request composer (PRD-005 / ARCH-028,
 * Batch IR-2b, IR-T-11, surface A).
 *
 * Route config only. Component lives in eric.input-requests.lazy.tsx
 * (code-split). No loader, beforeLoad, or validateSearch — the parent /eric
 * layout route already gates on requireOperatorEntry.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/input-requests')({});
